<div class="side-notes common-sidepanel-activity">      
    <div class="sidepanel-table">
      <div class="side-note-container" >
        <div class="notes-box" *ngFor="let note of WritingCodeNotesList">
          <div class="info-block">
            <span title="Note - 1">{{ note.note }}</span>
          </div>
          <div class="d-flex">
            <span class="time-note">{{note.createdBy }}</span>
            <span class="seprator mx-1"></span>
            <span class="time-note">
              {{note.createdOn | date:'MM/dd/yyyy hh:mm a' }}</span>
          </div>
        </div>
        <div class="no-data-found p-0 inside-attachment" *ngIf="(WritingCodeNotesList == null || (WritingCodeNotesList != null && WritingCodeNotesList.length <= 0))">
          <img src="../../../../assets/images/no-data.svg">
          <h5>No notes here</h5>
          <div>Notes would be visible here</div>
        </div>
      </div>
    </div>
    <div class="data-form" [formGroup]="writingCodeNote"> <!-- [class.d-none]="user?.archivedDate != null" -->


        <div class="text-count w-100">
            <textarea #chatInput maxlength="500"  class="form-control w-100" id=""
                    cols="30" rows="10" placeholder="Add a note..." formControlName="memo"></textarea>
                    <!-- [(ngModel)]="userNote.notes" -->
                    <!-- [disabled]="user?.archivedDate != null" (keyup.enter)="userNote.notes?.length > 0 ? onSubmit() : ''" -->
            <div class="notes-count w-100">
              <p class="m-0">({{ noteLength
              }}/500)</p>
              <!-- <p class="m-0">({{userNote.notes?.length > 0 ? userNote.notes?.length : 0}}/500)</p> -->
              <a class="commn-btn" href="javascript:void()"
                 (click)="insertNote()">Add</a>
              <!-- [class.disabled]="userNote.notes == null || userNote.notes?.length == 0" (click)="onSubmit()" -->
</div>
        </div>
    </div>
</div>
